// @flow

import * as React from 'react'

import { MDXProvider } from '@mdx-js/react'
import { ParallaxProvider } from 'react-scroll-parallax'
import { Context as AuthContext } from '@toggl/auth'
import ErrorPage from '../components/ErrorPage'
import Bugsnag from '@bugsnag/js'
import {
  connectivity,
  PluginReact,
  tracer,
  uptime,
  verbose,
} from '@toggl/bugsnag'

/*::
declare var process: WebProcess
*/
const environment = process.env.GATSBY_BUGSNAG_RELEASE_STAGE

Bugsnag.start({
  apiKey: process.env.GATSBY_BUGSNAG_API_KEY,
  appVersion: process.env.GATSBY_VERSION,
  endpoints: {
    notify: process.env.GATSBY_BUGSNAG_NOTIFY_ENDPOINT,
    sessions: process.env.GATSBY_BUGSNAG_SESSION_ENDPOINT,
  },
  enabledReleaseStages: [
    ('development' /*: ReleaseStage */),
    ('production' /*: ReleaseStage */),
  ],
  releaseStage: environment,

  // Disabled due to privacy concerns #6362 (https://git.io/vNClt).
  // If you believe they're now safe, reconsider enabling 💪!
  enabledBreadcrumbTypes:
    environment === 'production'
      ? []
      : [
          'navigation',
          'request',
          'process',
          'log',
          'user',
          'state',
          'error',
          'manual',
        ],

  autoTrackSessions: environment !== 'testing',
  autoDetectErrors: true,
  collectUserIp: false,
  logger: environment === 'production' ? null : verbose.logger,

  metadata: {
    connectivity: {
      interruptions: false,
      offline: false,
    },
  },

  onError: environment === 'production' ? null : verbose.onError,

  plugins: [new PluginReact(React), connectivity, uptime(), tracer],
})

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }: { element: React.Node }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <AuthContext.Provider>
        <MDXProvider>
          <ParallaxProvider>{element}</ParallaxProvider>
        </MDXProvider>
      </AuthContext.Provider>
    </ErrorBoundary>
  )
}
